// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Btn from "../../../html/Btn.js";
import * as Buhta_cabinet__Kassa from "../../../../grpc/Kassa.js";
import * as Buhta_cabinet__Route from "../../../../Route.js";
import * as Buhta_cabinet__Timestamp from "../../../../util/Timestamp.js";
import * as Buhta_cabinet__ToastSender from "../../../../util/ToastSender.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Tenant from "../../../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../../packages/util/lib/DateTime.js";
import * as $$Promise from "../../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as ReactCopyToClipboard from "react-copy-to-clipboard";
import * as JsxRuntime from "react/jsx-runtime";

function KkmView(Props) {
  let kkm = Props.kkm;
  let onMoneyPlacement = Props.onMoneyPlacement;
  let onCloseShift = Props.onCloseShift;
  let org = Props.org;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const match$1 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match$1[1];
  const currentUrlStr = Buhta_cabinet__Route.toString(Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined)));
  const match$2 = React.useState(function () {
    return false;
  });
  const setCopySerialHovered = match$2[1];
  const match$3 = React.useState(function () {
    return false;
  });
  const setSerialCopied = match$3[1];
  const match$4 = React.useState(function () {
    return false;
  });
  const setCopyRegisterHovered = match$4[1];
  const match$5 = React.useState(function () {
    return false;
  });
  const setRegisterCopied = match$5[1];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const match$6 = kkm.state;
  let tmp;
  switch (match$6) {
    case "initial" :
    case "pending" :
    case "registering" :
    case "unlinked" :
    case "unlinking" :
      tmp = null;
      break;
    default:
      tmp = JsxRuntime.jsxs(React.Fragment, {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("button", {
                children: JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                  children: "Внести в кассу"
                }),
                className: "rounded-sm border border-gray-main py-2.5 w-full",
                onClick: (function (param) {
                  Curry._1(onMoneyPlacement, true);
                })
              }),
              JsxRuntime.jsx("button", {
                children: JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                  children: "Снять из кассы"
                }),
                className: "rounded-sm border border-gray-main py-2.5 w-full",
                onClick: (function (param) {
                  Curry._1(onMoneyPlacement, false);
                })
              })
            ],
            className: "mt-6 flex gap-2"
          }),
          JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
            title: "Новая продажа",
            route: contextRoute({
              TAG: /* Kassa */ 2,
              _0: {
                TAG: /* Kkms */ 0,
                _0: {
                  TAG: /* Kkm */ 0,
                  _0: kkm.id,
                  _1: /* Cashbox */ 4
                }
              }
            }),
            link: true,
            className: "mt-6 w-full py-2.5",
            urlParams: {
              hd: [
                "return_to",
                currentUrlStr
              ],
              tl: /* [] */ 0
            },
            text: /* He5 */ 1
          }),
          kkm.shift_opened ? JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("button", {
                  children: JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                    children: "Снять X-отчет"
                  }),
                  className: "rounded-sm border border-gray-main py-2.5 w-full",
                  onClick: (function (param) {
                    const __x = Buhta_cabinet__Kassa.ZxReportService.createXReport(tenant, kkm.id, undefined);
                    $$Promise.get(__x, (function (result) {
                      if (result.TAG !== /* Ok */ 0) {
                        return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при снятии X-отчета.");
                      }
                      Curry._1(dispatchToasts, {
                        TAG: /* Add */ 0,
                        _0: {
                          id: Buhta_core__Toast.generateId(undefined),
                          text: "X-Отчет создан.",
                          kind: "success",
                          onClick: (function (param) {
                            
                          })
                        }
                      });
                      window.open(Buhta_cabinet__Route.toString(contextRoute({
                        TAG: /* Kassa */ 2,
                        _0: {
                          TAG: /* Kkms */ 0,
                          _0: {
                            TAG: /* Kkm */ 0,
                            _0: kkm.id,
                            _1: {
                              TAG: /* Journal */ 2,
                              _0: {
                                TAG: /* Shifts */ 0,
                                _0: {
                                  TAG: /* View */ 0,
                                  _0: result._0.id
                                }
                              }
                            }
                          }
                        }
                      })), "_blank", undefined);
                    }));
                  })
                }),
                JsxRuntime.jsx("button", {
                  children: JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                    className: kkm.shift_opened ? "text-alert" : "text-default-gray",
                    children: "Закрыть смену"
                  }),
                  className: "rounded-sm border border-gray-main py-2.5 w-full",
                  disabled: !kkm.shift_opened,
                  onClick: (function (param) {
                    Curry._1(onCloseShift, undefined);
                  })
                })
              ],
              className: "mt-4 flex gap-2"
            }) : JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("img", {
                  className: "w-5 h-5",
                  src: StaticAsset.src("/static/icons/please-note.svg")
                }),
                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  className: "text-default-gray",
                  children: "Продажа запустит новую смену"
                })
              ],
              className: "mt-4 flex gap-2"
            })
        ]
      });
  }
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                className: "text-gray-medium",
                children: "Серийный номер"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                    children: kkm.serial_num
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(ReactCopyToClipboard.CopyToClipboard, {
                      text: kkm.serial_num,
                      onCopy: (function (param) {
                        Curry._1(setSerialCopied, (function (param) {
                          return true;
                        }));
                        setTimeout((function (param) {
                          Curry._1(setSerialCopied, (function (param) {
                            return false;
                          }));
                        }), 3000);
                      }),
                      children: match$3[0] ? JsxRuntime.jsx("img", {
                          className: "cursor-pointer w-5 h-5",
                          src: StaticAsset.src("/static/icons/copy-check-20.svg")
                        }) : (
                          match$2[0] ? JsxRuntime.jsx("img", {
                              className: "cursor-pointer w-5 h-5",
                              src: StaticAsset.src("/static/icons/copy-black-20.svg")
                            }) : JsxRuntime.jsx("img", {
                              className: "cursor-pointer w-5 h-5",
                              src: StaticAsset.src("/static/icons/copy-gray-20.svg")
                            })
                        )
                    }),
                    className: "hover:bg-gray-light rounded-sm ml-1",
                    title: "Скопировать",
                    onClick: (function (ev) {
                      ev.preventDefault();
                      ev.stopPropagation();
                    }),
                    onMouseEnter: (function (param) {
                      Curry._1(setCopySerialHovered, (function (param) {
                        return true;
                      }));
                    }),
                    onMouseLeave: (function (param) {
                      Curry._1(setCopySerialHovered, (function (param) {
                        return false;
                      }));
                    })
                  })
                ],
                className: "flex"
              })
            ],
            className: "flex justify-between"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                className: "text-gray-medium",
                children: "Рег. номер"
              }),
              kkm.ofd_register_num !== "" ? JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                      children: kkm.ofd_register_num
                    }),
                    JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(ReactCopyToClipboard.CopyToClipboard, {
                        text: kkm.ofd_register_num,
                        onCopy: (function (param) {
                          Curry._1(setRegisterCopied, (function (param) {
                            return true;
                          }));
                          setTimeout((function (param) {
                            Curry._1(setRegisterCopied, (function (param) {
                              return false;
                            }));
                          }), 3000);
                        }),
                        children: match$5[0] ? JsxRuntime.jsx("img", {
                            className: "cursor-pointer w-5 h-5",
                            src: StaticAsset.src("/static/icons/copy-check-20.svg")
                          }) : (
                            match$4[0] ? JsxRuntime.jsx("img", {
                                className: "cursor-pointer w-5 h-5",
                                src: StaticAsset.src("/static/icons/copy-black-20.svg")
                              }) : JsxRuntime.jsx("img", {
                                className: "cursor-pointer w-5 h-5",
                                src: StaticAsset.src("/static/icons/copy-gray-20.svg")
                              })
                          )
                      }),
                      className: "hover:bg-gray-light rounded-sm ml-1",
                      title: "Скопировать",
                      onClick: (function (ev) {
                        ev.preventDefault();
                        ev.stopPropagation();
                      }),
                      onMouseEnter: (function (param) {
                        Curry._1(setCopyRegisterHovered, (function (param) {
                          return true;
                        }));
                      }),
                      onMouseLeave: (function (param) {
                        Curry._1(setCopyRegisterHovered, (function (param) {
                          return false;
                        }));
                      })
                    })
                  ],
                  className: "flex"
                }) : null
            ],
            className: "flex justify-between mt-2"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                className: "text-gray-medium",
                children: "Соединение с ОФД"
              }),
              kkm.connected ? JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  className: "text-gray-medium",
                  children: "Подключено"
                }) : JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  className: "text-alert",
                  children: "Отключено"
                })
            ],
            className: "flex justify-between mt-2"
          }),
          JsxRuntime.jsx("hr", {
            className: "mt-6"
          }),
          JsxRuntime.jsx(Buhta_components__Text.Label.make, {
            className: "mt-6 text-default-gray",
            children: "смена"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Buhta_components__Text.H1.make, {
                    children: "#" + String(kkm.shift_id)
                  }),
                  kkm.shift_opened ? JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                        className: "text-white",
                        children: "Открыта"
                      }),
                      className: "bg-success rounded-sm px-2 py-0.5 ml-2"
                    }) : JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                        className: "text-white",
                        children: "Закрыта"
                      }),
                      className: "bg-gray-medium rounded-sm px-2 py-0.5 ml-2"
                    })
                ],
                className: "flex items-center"
              }),
              kkm.shift_opened ? JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  className: "text-right text-gray-medium",
                  children: "с " + DateTime.toLocalFormat(Buhta_cabinet__Timestamp.toDateTime(Belt__Belt_Option.getWithDefault(kkm.shift_open_time, Buhta_cabinet__Timestamp.fromString("01.01.2000"))))
                }) : null
            ],
            className: "mt-1 flex items-center justify-between"
          }),
          tmp
        ],
        className: "w-110 bg-white p-6 rounded-md shadow-kkms"
      }),
      className: "w-full h-full bg-gray-pale px-4 lg:px-6 py-6 flex gap-6 items-start"
    }),
    className: "w-full"
  });
}

const timeout = 3000;

const make = KkmView;

export {
  timeout,
  make,
}
/* Buhta_cabinet__Btn Not a pure module */
